import styled from '@emotion/styled'

export const Wrapper = styled.footer`
  position: fixed;
  width: max-content;
  background: #3c3e44;
  color: #fff;
  bottom: 0;
  right: 0;
  font-size: 12px;
  padding: 5px;
  a {
    color: #9e9e9e;
    transition: 0.5s ease;
    :hover {
      color: #fff;
    }
  }
`
